import React from 'react';
import RequestComponent from '../Other/RequestComponent';
import MarqueeText from '../Other/MarqueeText';

function Services() {
    return (
        <div>
             <div class="common-hero" style={{width:'100%', backgroundSize:'cover'}}>
                <div class="container">
                    <div class="row align-items-center text-center">
                        <div class="col-lg-6 m-auto">
                            <div class="main-heading">
                                {/* <h1>About Us</h1>
                                <div class="space16"></div>
                                <span class="span"> <a href="/">Home</a> <span class="arrow"><i class="fa-regular fa-angle-right"></i></span> About Us</span> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <section class="hero10-benar">
                <div class="container-fluid p-0">
                    <div class="row">
                        <div class="col-12">
                            <MarqueeText/>
                        </div>
                    </div>

                    <div class="slider-after"></div>
                </div>
            </section>
            
            <div class="space100"></div>
            <div class="servcie2 service-page-sec">
                <div class="container">
                    <div class="row">
                    <div class="col-lg-6 col-md-6">
                            <div class="">
                                <div class="servcie2-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/service-page-icon5.png" alt="" />
                                    </div>
                                    <a href="#" class="arrow"><i class="fa-solid fa-arrow-right"></i></a>
                                    <div class="heading1">
                                        <h4><a href="#">Cross-Platform Expertise</a></h4>
                                        <div class="space16"></div>
                                        <p>Our deep domain knowledge spans the entire ServiceNow ecosystem — including ITSM, ITOM, HRSD, CSM, SecOps, App Engine, GRC, and more — enabling truly integrated enterprise solutions.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                       

                        <div class="col-lg-6 col-md-6">
                            <div class="">
                                <div class="servcie2-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/service-page-icon2.png" alt="" />
                                    </div>
                                    <a href="#" class="arrow"><i class="fa-solid fa-arrow-right"></i></a>
                                    <div class="heading1">
                                        <h4><a href="#">End-to-End Implementation</a></h4>
                                        <div class="space16"></div>
                                        <p>From architecture and design to development and deployment, we manage full lifecycle ServiceNow implementations across all modules, delivering scalable solutions with speed, precision, and adherence to best practices.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="">
                                <div class="servcie2-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/service-page-icon3.png" alt="" />
                                    </div>
                                    <a href="#" class="arrow"><i class="fa-solid fa-arrow-right"></i></a>
                                    <div class="heading1">
                                        <h4><a href="#">Training & Enablement</a></h4>
                                        <div class="space16"></div>
                                        <p>Empower your workforce with tailored training programs for administrators, developers, and end-users — designed to build in-house capabilities and ensure long-term platform success.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="">
                                <div class="servcie2-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/service-page-icon4.png" alt="" />
                                    </div>
                                    <a href="#" class="arrow"><i class="fa-solid fa-arrow-right"></i></a>
                                    <div class="heading1">
                                        <h4><a href="#">Platform Optimization & Enhancements</a></h4>
                                        <div class="space16"></div>
                                        <p>We continuously optimize your ServiceNow environment by improving performance, streamlining workflows, and implementing new features that evolve with your business needs.</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="">
                                <div class="servcie2-box">
                                    <div class="icon">
                                        <img src="assets/img/icons/service-page-icon1.png" alt="" />
                                    </div>
                                    <a href="#" class="arrow"><i class="fa-solid fa-arrow-right"></i></a>
                                    <div class="heading1">
                                        <h4><a href="#">ServiceNow Strategy & Advisory</a></h4>
                                        <div class="space16"></div>
                                        <p>We provide strategic guidance through platform assessments, roadmap development, and value realization planning — ensuring alignment with your business objectives and maximizing ROI.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        

                        

                    </div>

                </div>
            </div>
            <div className="work sp">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="heading1">
                <span className="span" data-aos="zoom-in-left" data-aos-duration="700">Best IT Solution</span>
                <h2 className="title tg-element-title"> Our ServiceNow Expertise</h2>
                <div className="space16"></div>
                <p data-aos="fade-right" data-aos-duration="700">At M2V Consulting, we deliver end-to-end solutions across the entire ServiceNow ecosystem — enabling enterprises to streamline operations, enhance experiences, and accelerate digital transformation.</p>

                <div className="single-items" data-aos="fade-right" data-aos-duration="700">
                  <div className="">
                    <div className="icon">
                      <img src="assets/img/icons/work-iocn1.png" alt="" />
                    </div>
                  </div>
                  <div className="">
                    <h4><a href="#">IT Workflows</a></h4>
                    <div className="space10"></div>
                    <p>Streamline IT operations with ITSM, ITOM, ITAM, CMDB, and Cloud Management.</p>
                  </div>
                </div>

                <div className="single-items" data-aos="fade-right" data-aos-duration="900">
                  <div className="">
                    <div className="icon">
                      <img src="assets/img/icons/work-iocn2.png" alt="" />
                    </div>
                  </div>
                  <div className="">
                    <h4><a href="#">Employee Workflows</a></h4>
                    <div className="space10"></div>
                    <p>Improve employee experience with HR and Workplace Service Delivery.

</p>
                  </div>
                </div>

                <div className="single-items" data-aos="fade-right" data-aos-duration="1100">
                  <div className="">
                    <div className="icon">
                      <img src="assets/img/icons/work-iocn3.png" alt="" />
                    </div>
                  </div>
                  <div className="">
                    <h4><a href="#">Customer Workflows</a></h4>
                    <div className="space10"></div>
                    <p>Enhance customer support through CSM and Field Service Management.</p>
                  </div>
                </div>


              </div>
              <div className="space30"></div>
              {/* <div className="" data-aos="fade-right" data-aos-duration="800">
                <a className="theme-btn1" href="/services">What we Offer <span><i className="fa-solid fa-arrow-right"></i></span></a>
              </div> */}
            </div>

            <div className="col-lg-6">
              <div className="work-images">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="image reveal image-anime">
                      <img src="assets/img/work/work-img1.png" alt="" />
                    </div>
                    <div className="image reveal image-anime">
                      <img src="assets/img/work/work-img3.png" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="image reveal image-anime">
                      <img src="assets/img/work/work-img2.png" alt="" />
                    </div>
                  </div>
                </div>
                <img src="assets/img/bg/it-consulting.png" alt="" className="bg-image " />
              </div>
            </div>
          </div>
        </div>
      </div>
            {/* <div class="solution about-solution sp">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <div class="images">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="image">
                                            <img src="assets/img/about/visiton-img1.png" alt="" />
                                        </div>
                                    </div>

                                    <div class="col-lg-6">
                                        <div class="space30"></div>
                                        <div class="image">
                                            <img src="assets/img/about/visiton-img2.png" alt="" />
                                        </div>
                                    </div>

                                    <div class="col-lg-6">
                                        <div class="space30"></div>
                                        <div class="image">
                                            <img src="assets/img/about/visiton-img3.png" alt="" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="heading1">
                                <span class="span"> Our Vision</span>
                                <h2>Driving Innovation: Our Vision at M2V Consulting</h2>
                                <div class="space16"></div>
                                <p>At M2V Consulting, we go beyond implementation — we unlock the full potential of the ServiceNow platform. Whether you're just beginning your digital journey or scaling enterprise-wide capabilities, we’re the trusted partner to guide you every step of the way.</p>

                                <div class="item-box">
                                    <div class="icon">
                                        <div class="">
                                            <img src="assets/img/icons/about-solution-iocn1.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="">
                                        <h3><a href="#">Network Infrastructure Solutions</a></h3>
                                        <div class="space10"></div>
                                        <p>Build a reliable and secure network infrastructure that supports your <br/> business operations and enables seamless connectivity across all levels.</p>
                                    </div>
                                </div>

                                <div class="item-box">
                                    <div class="icon">
                                        <div class="">
                                            <img src="assets/img/icons/about-solution-iocn2.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="">
                                        <h3><a href="#">Managed It Services</a></h3>
                                        <div class="space10"></div>
                                        <p>Focus on your core business activities while we manage and optimize your <br/> IT environment with our comprehensive managed services.</p>
                                    </div>
                                </div>

                                <div class="space30"></div>
                                <div class="">
                                    <a class="theme-btn1" href="/contact_us">Contact Us <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div> 
                            </div>
                        </div>

                    </div>
                </div>
            </div> */}
            {/* <RequestComponent/> */}
        </div>
    );
}

export default Services;